export const messages = {
  en: {
    buyGoldSend: {
      title: 'Send Coupon',
      coupon: 'Coupon',
      stock: 'Stock',
      sendCount: 'Send Count',
      member: 'Member',
      select: 'Select',
      return: 'Return',
      confirmSend: 'Confirm Send',
      insufficientStock: 'Insufficient stock, please purchase coupons first!',
      selectMember: 'Please select member information'
    }
  },
  zh: {
    buyGoldSend: {
      title: '赠送优惠券',
      coupon: '优惠券',
      stock: '库存',
      sendCount: '赠送数量',
      member: '会员',
      select: '选择',
      return: '返回',
      confirmSend: '确认赠送',
      insufficientStock: '库存不足，请先购买优惠卷！',
      selectMember: '请选择会员信息'
    }
  }
}